var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.09627 5.22102L3.97127 8.34602C3.94223 8.37506 3.90776 8.39809 3.86983 8.4138C3.83189 8.42952 3.79123 8.4376 3.75017 8.4376C3.70911 8.4376 3.66845 8.42952 3.63052 8.4138C3.59258 8.39809 3.55811 8.37506 3.52908 8.34602C3.50005 8.31699 3.47701 8.28252 3.4613 8.24459C3.44559 8.20665 3.4375 8.16599 3.4375 8.12493C3.4375 8.08387 3.44559 8.04321 3.4613 8.00527C3.47701 7.96734 3.50005 7.93287 3.52908 7.90384L6.43338 4.99993L3.52908 2.09602C3.47044 2.03739 3.4375 1.95786 3.4375 1.87493C3.4375 1.792 3.47044 1.71247 3.52908 1.65384C3.58772 1.5952 3.66725 1.56226 3.75017 1.56226C3.8331 1.56226 3.91263 1.5952 3.97127 1.65384L7.09627 4.77884C7.12532 4.80786 7.14837 4.84232 7.1641 4.88026C7.17983 4.9182 7.18792 4.95886 7.18792 4.99993C7.18792 5.041 7.17983 5.08166 7.1641 5.1196C7.14837 5.15754 7.12532 5.192 7.09627 5.22102Z",
    fill: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.699e264673bcaae819d2e499b3434cf1.svg";
export { ForwardRef as ReactComponent };